import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  colorWhite: {
    color: 'white',
  },
  info: {
    backgroundColor: 'black',
    width: 20,
    borderRadius: 15,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  bold: {
    fontWeight: 'bold',
    fontSize: 18,
  },

  modalText: {
    fontSize: 16,
    fontWeight: '400',
    marginBottom: 15,
    textAlign: 'left',
  },
  loaderWrapper: {
    marginTop: -10,
    marginLeft: -20,
    paddingRight: 45,
    paddingLeft: 10,
    right: 0,
    bottom: 0,
    backgroundColor: 'gray',
    width: '120%',
  },
  loaderBody: {
    marginTop: '50%',
    marginBottom: '100%',
    marginLeft: 20,
    marginRight: 30,
    padding: 40,
    borderRadius: 40,
    backgroundColor: 'white',
  },
});
